import { Component, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { Performer, performerProps } from 'src/app/store/performers.era';
import { ShareWrapper } from './share-wrapper.component';
import { CustomQuestion } from 'globals/store/events.data';
import { JoiTemplate } from 'globals/store/publish.data';
import { CommonModule } from '@angular/common';
import { BrandingWrapperComponent } from 'src/app/components/branding/branding-wrapper.component';
import { CustomQuestionsComponent } from 'src/app/components/entities/custom-questions.component';
import { InputEditorComponent } from 'src/app/components/joi-input/input-editor';
import { LoaderComponent } from 'src/app/components/loader/loader.component';
import { SocialLinksComponent } from 'src/app/components/social-links/social-links.component';
import { AddManageWrapperComponent } from 'src/app/components/wrappers/add-manage-wrapper.component';
import { MutatingInputComponent } from 'src/app/components/joi-input/mutating-input.component';
import { ImageUploaderComponent } from 'src/app/components/wrappers/image-uploader.component';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Subject } from 'rxjs';

@Component({
    selector: 'share-edit-performer-form',
    template: `
<div class="event-name ">{{ topTitle }}</div>
<div class="instructions body-text" *ngIf="!!instructions" [innerHTML]="instructions"></div>
<div class="top">
  <div class="photos">
    <image-uploader 
      #photoEditor 
      [id]="performer.id || ''" 
      [publishCode]="publishCode"
      [public]="true"
      [photoUrl]="performer.fullPhotoUrl" 
      [hints]="imageHints"
      [eventId]="eventId" 
      type="performer" 
      subtype="photo" 
      placeholder="Add photo"
    ></image-uploader>
    <image-uploader 
      #logoEditor 
      [id]="performer.id || ''"
      [isLogo]="true"
      [publishCode]="publishCode"
      [public]="true"
      [photoUrl]="performer.fullLogoUrl" 
      [hints]="imageHints" 
      [eventId]="eventId"
      type="performer" 
      subtype="logo" 
      placeholder="Add logo" 
      uploadText="UPLOAD LOGO"
    ></image-uploader>
  </div>
  <div class="fields body-text">
    <mutating-input [object]="performer" [prop]="props.name" placeholder="Performer name"></mutating-input>
    <mutating-input [object]="performer" [prop]="props.line1" hint="e.g. Job title" placeholder="Line 1" ></mutating-input>
    <mutating-input [object]="performer" [prop]="props.line2" hint="e.g. Company" placeholder="Line 2" ></mutating-input>
    <mutating-input [object]="performer" [prop]="props.contactName" [placeholder]="'Performer contact name'" ></mutating-input>
    <mutating-input [object]="performer" [prop]="props.email" [placeholder]="'Performer contact email'" ></mutating-input>
    <mutating-input [object]="performer" [prop]="props.phone" [placeholder]="'Performer contact phone'" ></mutating-input>
    <h5>Performer contact address</h5>
    <input-editor 
      class="placeholder-no-italics"
      [object]="performer" 
      [prop]="'contactFullAddress'" 
      [forceSave]="forceSave"
      [placeholder]="'Performer contact address...'"
    ></input-editor>
    <add-manage-wrapper class="social-open" [hideHRule]="true" wrapperTitle="SOCIAL" [openLabel]="!performer.social?.length ? '+ ADD A SOCIAL LINK' : 'MANAGE SOCIAL LINKS'" (open)="openSocialLinks($event, performer)">
      <social-links *ngIf="performer?.social?.length" [socialLinks]="performer.social || []"></social-links>
    </add-manage-wrapper>
  </div>
</div>
<div class="bottom">
  <h5>Bio</h5>
  <input-editor 
    class="placeholder-no-italics body-text"
    [object]="performer" 
    [prop]="props.bio" 
    [placeholder]="'Bio'"
    [forceSave]="forceSave"
  ></input-editor>
  <custom-questions class="body-text"
    [entity]="performer"
    [showMandatoryWarnings]="showMandatoryWarnings"
    [questions]="customQuestions"
    [shareView]="true"
    (updateQuestion)="updateCustomQuestion($event, performer)"
  ></custom-questions>

  <button mat-button color="primary" (click)="submit()" [disabled]="processing || logoEditor.imageChanging || photoEditor.imageChanging" >
    <div class="button_content">
      Submit
      <loader icon="button_wheel"></loader>
    </div>
  </button>
  <div class="error-holder" *ngIf="error" [innerHTML]="helpers.strWithBreak(error)"></div>
</div>
    `,
    styleUrls: ['./share.editPerformer.scss'],
    standalone: true,
    imports: [CommonModule, MatButtonModule, MatFormFieldModule, MatInputModule, CustomQuestionsComponent, InputEditorComponent, LoaderComponent, SocialLinksComponent, AddManageWrapperComponent, MutatingInputComponent, ImageUploaderComponent ],
})
export class PerformerEditProfileComponent extends ShareWrapper<PerformerEditProfileComponent> {
    forceSave: Subject<void> = new Subject<void>();
    @ViewChild('photoEditor') photoEditor
    @ViewChild('logoEditor') logoEditor
    props = performerProps
    showMandatoryWarnings = false;
    @Input() topTitle: string
    @Input() eventId: string
    @Input() performer:Performer
    @Input() publishCode // in the case of 
    @Input() customQuestions: CustomQuestion[] = []
    @Input() error
    @Input() processing: boolean
    @Input() callToSubmit: boolean
    @Input() instructions: string
    @Input() template: JoiTemplate
    
    @Output() onSubmit: EventEmitter<Performer> = new EventEmitter()


    async submit() {
      // CHECK FOR MANDATORY FIELDS
      const allRequirementsCompleted = await this.publicService.checkForMandatory(this.customQuestions, this.performer.customQuestions);
      if(!allRequirementsCompleted) {
        this.showMandatoryWarnings = true;
        return;
      }
      if (this.photoEditor.deleteDeletedPhotos()) {
        this.performer.photoUrl = this.photoEditor.tempThumbUrl
        this.performer.fullPhotoUrl = this.photoEditor.tempUrl

      }
      if (this.logoEditor.deleteDeletedPhotos()) {
        this.performer.logoUrl = this.logoEditor.tempThumbUrl
        this.performer.fullLogoUrl = this.logoEditor.tempUrl
      }

      this.forceSave.next();
      this.onSubmit.emit(this.performer)
    }
}

